import { doGet, doPost, doPut, doPatch, doDelete } from 'src/api/client';

export async function reqGetProfile() {
  return doGet(`user/profile`);
}

export async function reqUpdatePreferences(prefs) {
  return doPut(`user/preferences`, prefs);
}

export async function reqUpdateWidgets(widgets) {
  return doPut(`user/widgets`, widgets);
}

/**
 * The payload must be an object with the following attributes (all mandatory):
 * email: string
 * role: string
 * companyName: string
 * lang: string
 */
export async function reqInviteUser(payload) {
  return doPost(`user/invite`, payload);
}

export async function reqResendUserInvite(userId) {
  return doPost(`user/${userId}/resend_invite`);
}

export async function reqUpdateUserRole(userId, newRole) {
  return doPut(`user/${userId}/role`, newRole);
}

export async function reqDeleteUser(userId) {
  return doDelete(`user/${userId}`);
}

/**
 * A user can be registered via this function.
 * Two cases: the user is completely new, so he does not have a token. Then we must make sure the username, email and company
 * are not already taken. Indeed, if a new user add a company that already exists, he will be linked to this company...
 * Second case: It has been invited by someone in the app, so he has a token, then he will be attached to his company
 * The function accept an object having the following attributes:
 * username: string
 * password: string
 * email: string
 * name: string
 * surname: string
 * company: string
 * token: string
 */
export async function reqUserRegistration(payload) {
  return doPost(`user`, payload);
}

/**
 * Check the status of a database token.
 * token: string
 */
export async function reqGetTokenStatus(payload) {
  return doGet(`user/token_status`, payload);
}

export async function reqGetUser() {
  return doGet(`user`);
}

/**
 * Updates an user.
 * The function accept an object having the following attributes:
 * user_id: string
 * username: string
 * email: string
 * name: string
 * surname: string
 */
export async function reqUpdateUser(user_id, payload) {
  return doPatch(`user/${user_id}`, payload);
}

/**
 * Updates the token by requesting a new sending of email
 * token: string MANDATORY
 * lang: string MANDATORY
 */
export async function reqResetRegistrationLink(params) {
  return doGet(`user/regen_token`, params);
}

/**
 * Updates the password.
 * The function accept an object having the following attributes:
 * userId: string MANDATORY
 * newPwd: string MANDATORY
 * oldPwd: string This or dbToken must be set
 * dbToken: string This or oldPwd must be set. This is the token that was sent by email. Normally due to lost password.
 */
export async function reqUpdatePwd(payload) {
  return doPost(`user/password/edit`, payload);
}

export async function reqUpdateUserCompany(userId, companyId) {
  return doPut(`user/${userId}/company_id`, companyId);
}

export async function reqGetActiveUsers() {
  return doGet(`users/active`);
}

export async function reqUpdateUserAccess(userId, hasAccessToCompliance) {
  return doPut(`user/${userId}/access/compliance`, hasAccessToCompliance);
}

export async function reqSaveApiKeyPreferences(technicalUserId, preferences) {
  return doPut(`user/${technicalUserId}/technical/preferences`, preferences);
}
